// extracted by mini-css-extract-plugin
export var rootSummary = "NZ4i";